<template>
  <section class="how-to">
    <div class="container">
      <header class="header">
        <SectionTitle :small="true" class="title">
          {{ title }}
        </SectionTitle>
        <p v-if="subtitle" class="subtitle">{{ subtitle }}</p>
      </header>
      <div class="info">
        <p>
          {{ text }}
        </p>
        <a :href="buttonAction" target="_blank" class="button">{{
          buttonText
        }}</a>
      </div>
    </div>
  </section>
</template>

<script>
import SectionTitle from "@/components/common/SectionTitle.vue";
export default {
  name: "HowToSection",
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    buttonText: {
      type: String,
      required: true,
    },
    buttonAction: {
      type: String,
      required: true,
    },
  },
  components: {
    SectionTitle,
  },
};
</script>

<style scoped>
.how-to:last-child {
  margin-bottom: clamp(4rem, 1.4455rem + 9.505vw, 10rem);
}
.container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  flex-wrap: wrap;
}

.header {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}
@media screen and (min-width: 768px) {
  .header {
    gap: 1rem;
    max-width: 538px;
  }
}
@media screen and (min-width: 1024px) {
  .header {
    gap: 56px;
    width: 43%;
  }
}

.how-to .title {
  text-align: right;
}

.title:only-child {
}

.subtitle {
  text-transform: uppercase;
  font-weight: 400;
  font-family: "Krona One", sans-serif;
  line-height: 1.5;
  font-size: clamp(1.5rem, 1.2871rem + 0.7921vw, 2rem);
}
@media screen and (min-width: 1024px) {
  .title {
    max-width: 414px;
  }
  .subtitle {
    max-width: 392px;
    margin-left: auto;
  }
}
@media screen and (max-width: 1024px) {
  .subtitle {
    display: none;
  }
}

.info {
  background-color: var(--color-primary);
  color: var(--color-off-white);
  padding: 48px;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  font-weight: 500;
  /* font-size: 1.375rem; */
  font-size: clamp(1rem, 0.8403rem + 0.5941vw, 1.375rem);
  line-height: 1.3;
  border-radius: 8px;
}
@media screen and (min-width: 1024px) {
  .info {
    max-width: 568px;
    width: 50%;
  }
}

.info a {
  color: currentColor;
}

.button {
  background-color: none;
  border: 1.5px solid currentColor;
  color: var(--color-off-white);
  font-size: 24px;
  font-weight: 400;
  border-radius: 8px;
  padding: 18px 24px;
  text-decoration: none;
  display: flex;
  text-transform: uppercase;
  width: fit-content;
  transition: all 0.3s;
}
.button:hover {
  background-color: var(--color-off-white);
  color: var(--color-primary);
}
</style>
